import {StyleSheet} from 'react-native';

// Theme-aware styles factory (the makeStyles pattern — docs/DARK-MODE.md):
// consumed via useThemedStyles(makeStyles) so colors re-resolve on theme
// change instead of baking at module load.
const makeStyles = colors =>
  StyleSheet.create({
    container: {
      padding: 12,
      flexDirection: 'column',
      backgroundColor: colors.surface,
      marginTop: 16,
      borderRadius: 16,
      shadowRadius: 30,
      shadowColor: colors.shadow,
      shadowOffset: {height: 0, width: 0},
      shadowOpacity: 0.12,
      width: '330px',
      height: '350px',
    },
    image: {
      width: '100%',
      height: '55%',
      aspectRatio: 1.6,
      borderRadius: 8,
      overflow: 'hidden',
    },
    content: {
      marginLeft: 16,
      flex: 1,
      alignItems: 'flex-start',
    },
    tagContainer: {
      padding: 8,
      backgroundColor: colors.backgroundMuted,
      borderRadius: 8,
      marginTop: 10,
    },
  });

export default makeStyles;
